import en from '@/components/CustomCharts/lang/en';
import ja from '@/components/CustomCharts/lang/ja';

export default {
  en,
  ja,
};
